<template>
<div>
    <blog-form 
      :is-blog-form-sidebar-active.sync="isBlogFormSidebarActive"
      :blog-data="blogData"
      @refetch-data="refetchData"
    />
    <b-card no-body>
        <div class="m-2">
            <b-row>
                <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                
                </b-col>
                <b-col
                    cols="12"
                    md="6"
                >
                    <div class="d-flex align-items-center justify-content-end">
                        <v-select
                            id="category_id"
                            class="d-inline-block width-350 mr-1"
                                v-model="catFilter"
                                placeholder="Filter By Category"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="title"
                                :reduce="(option) => option.id"
                                
                                :options="catsData.map(g => ({title: g.title[currentLocale], id: g.id}))"
                        />
                        <b-form-input
                            v-model="searchQuery"
                            class="d-inline-block mr-1"
                            placeholder="Search..."
                        />
                        <b-button
                        variant="primary"
                        @click="updateBlog()"
                        >
                            <span class="text-nowrap">Add Blog</span>
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </div>
        <b-table
            v-if="!blogs.length"
            :items="blogs"
            responsive
            :fields="tableColumns"
            show-empty
            empty-text="No matching records found"
            class="position-relative"
        >
        </b-table>
        <table v-else class="table table-striped">
            <thead>
                <tr>
                <th scope="col" v-for="col in tableColumns">
                    {{col.label}}
                </th>
                </tr>
            </thead>
        <draggable v-model="blogs" tag="tbody" hadle=".handle" @change="updateBlogsOrdering()">
            <tr v-for="(item, index) in blogs" :key="index">
                <th scope="row" class="pl-2">
                    <!-- <MenuIcon icon="MenuIcon"/>  -->
                </th>
                <td class="pl-2">
                    <b-img
                    :src="(item.cover_image?item.fullpath:require('@/assets/images/no-image.png'))"
                    height="110"
                    width="170"
                    class="rounded m-0"
                    />
                </td>
                <td class="pl-2">
                    <span>{{item.title[currentLocale]}}</span>
                </td>
                <td class="pl-2">
                    <span>{{item.slug[currentLocale]}}</span>
                </td>
                <td class="pl-2">
                    <span v-for="(cat,key) in item.cats" :key="'cat-port+'+item.id+'-'+key">
                            <template v-if="key === 0">{{ cat.title[currentLocale]  }}</template>
                            <template v-else>, {{ cat.title[currentLocale] }}</template>
                    </span>
                </td>
                <td class="pl-2">
                    <b-badge
                    pill
                    :variant="`light-${resolveCatStatusVariant(item.is_active)}`"
                    class="text-capitalize"
                    >
                        {{ resolveCatStatusnameVariant(item.is_active) }} 
                    </b-badge>
                </td>
                <td class="pl-2">
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateBlog(item)" variant="outline-success">Edit</b-button>
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                </td>
            </tr>
        </draggable>
    </table>
        <div class="mx-2 mb-2">
            <b-row>
                <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                    <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                </b-col>
                <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalBlogs"
                        :per-page="perPage"
                        first-number
                        last-number
                        class="mb-0 mt-1 mt-sm-0"
                        prev-class="prev-item"
                        next-class="next-item"
                    >
                        <template #prev-text>
                            <feather-icon
                                icon="ChevronLeftIcon"
                                size="18"
                            />
                            </template>
                            <template #next-text>
                            <feather-icon
                                icon="ChevronRightIcon"
                                size="18"
                            />
                        </template>
                    </b-pagination>
                </b-col>
            </b-row>
        </div>
    </b-card>
</div>
</template>
<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,BImgLazy
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
//api
import axios from '@axios'
import store from '@/store'
import { ref,onUnmounted } from '@vue/composition-api'
import useBlogList from './useBlogList'
import blogStoreModule from '../blogStoreModule'
import BlogForm from '../blog-form/BlogForm.vue'
import BlogSectionForm from '../blog-form/BlogSectionForm.vue'

import vSelect from 'vue-select'
import draggable from 'vuedraggable'
//import { FeatherIcon, MenuIcon } from 'vue-feather-icons'
export default {
    components:{
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
        BlogForm,BImg,BImgLazy,draggable,
        vSelect,BlogSectionForm
    }, 
   
  
    directives:{
        'b-modal': VBModal,
        Ripple

    },
    computed: {
       
       currentLocale() {
         return  this.$i18n.locale;
       },
   },
    setup(){
        const CAT_STORE_MODULE_NAME = 'app-blog';
        if (!store.hasModule(CAT_STORE_MODULE_NAME)) store.registerModule(CAT_STORE_MODULE_NAME, blogStoreModule)
        onUnmounted(() => {
            if (store.hasModule(CAT_STORE_MODULE_NAME)) store.unregisterModule(CAT_STORE_MODULE_NAME)
        });
       
        const {
            blogData,
            isBlogFormSidebarActive,
            refCatListTable,
            tableColumns,
            perPage,
            totalBlogs,
            currentPage,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            statusFilter,
            dataMeta,
            refetchData,
            fetchData,
            resolveCatStatusVariant,
            resolveCatStatusnameVariant,
            updateBlog,
            deleteData,
            catsData,
            catFilter,
            t,
            updateBlogsOrdering,
            blogs
        } = useBlogList();

        fetchData();
        return {
            blogData,
            isBlogFormSidebarActive,
            refCatListTable,
            tableColumns,
            perPage,
            totalBlogs,
            currentPage,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            statusFilter,
            dataMeta,
            refetchData,
            fetchData,
            resolveCatStatusVariant,
            resolveCatStatusnameVariant,
            updateBlog,
            deleteData,
            catsData,
            catFilter,
            t,
            updateBlogsOrdering,
            blogs
        }


    },
    methods:{
        deleteconfirm(id){
            this.$bvModal
                .msgBoxConfirm('Please confirm that you want to delete Blog ID.'+id, {
                title: 'Please Confirm',
                size: 'sm',
                okVariant: 'danger',
                okTitle: 'Yes',
                cancelTitle: 'No',
                cancelVariant: 'outline-secondary',
                hideHeaderClose: false,
                centered: true,
                })
                .then(value => {
                if(value === true){
                this.deleteData(id)
                }
            
                //this.deleteData(id)
                })

        },
    }
}

</script>
